import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';
import { buildNeogtmDeepLinkPagePath, resolveNeogtmTarget } from '@/lib/chatbotDeepLinks';
import { useChatMessageLinks } from '@/components/ChatMessageLinksContext';

const linkClassName = 'break-words underline text-[#00C2C2] hover:text-[#00A3A3]';
const linkStyle = { userSelect: 'text', WebkitUserSelect: 'text' };

function linkLabelFromChildren(children) {
  if (typeof children === 'string') return children;
  if (Array.isArray(children)) return children.map((c) => (typeof c === 'string' ? c : '')).join('');
  return '';
}

export default function ChatMarkdownAnchor({ children, href, ...props }) {
  const { linkRegistry, people } = useChatMessageLinks();
  const linkLabel = linkLabelFromChildren(children);
  const pagePath = buildNeogtmDeepLinkPagePath(href, { linkRegistry, people, linkLabel });

  if (pagePath) {
    return (
      <Link
        {...props}
        to={createPageUrl(pagePath)}
        className={linkClassName}
        onClick={(e) => e.stopPropagation()}
        style={linkStyle}
      >
        {children}
      </Link>
    );
  }

  const parsed = href?.startsWith('neogtm://')
    ? resolveNeogtmTarget(href, linkRegistry, { people, linkLabel })
    : null;
  if (parsed) {
    return (
      <span {...props} className={`${linkClassName} cursor-default opacity-80`} style={linkStyle}>
        {children}
      </span>
    );
  }

  if (!href) {
    return (
      <span {...props} className={linkClassName} style={linkStyle}>
        {children}
      </span>
    );
  }

  return (
    <a
      {...props}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={linkClassName}
      onClick={(e) => e.stopPropagation()}
      style={linkStyle}
    >
      {children}
    </a>
  );
}
